module.exports = __webpack_public_path__ + "static/media/vvs_logo.759d22df.svg";